import {getEnvironment} from '@sail/utils';

import type {ServiceName} from 'src/internal/common/types';
import type {AelErrorEvent} from 'src/internal/errors/transport/types';

export const ERRORS_R_URL = 'https://r.stripe.com/e';
export const ERRORS_QA_R_URL = 'https://qa-r.stripe.com/e';
export const AEL_ERRORS_BATCH_SIZE = 200;

export function getAelErrorsUrl(): string {
  return getEnvironment() === 'production' ? ERRORS_R_URL : ERRORS_QA_R_URL;
}

export function serializeAelErrorsBatchBody(
  service: ServiceName,
  errors: AelErrorEvent[],
): string {
  return JSON.stringify({
    client_id: service,
    errors,
  });
}
